import { useState } from 'react';

export function useModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

    function openModal(content: JSX.Element) {
        setModalContent(content);
        setIsModalOpen(true);
    }

    function closeModal() {
        setModalContent(null);
        setIsModalOpen(false);
    }

    return {
        isModalOpen,
        openModal,
        closeModal,
        modalContent,
    };
}